import React, { useContext } from 'react'

import { Brand } from '@awaze/design-system.components.awaze-theme-provider'

type ApplicationConfigContext = {
  brand: Brand
  clientHeader: string
  contentfulLocale: string
  currency: string
  themeBrand: Brand
}

const ApplicationConfigContext =
  React.createContext<ApplicationConfigContext | null>(null)

export const useApplicationConfig = (): ApplicationConfigContext => {
  const context = useContext(ApplicationConfigContext)

  if (!context) {
    throw new Error(
      'useApplicationConfig must be used within ApplicationConfigProvider',
    )
  }

  return context
}

export const ApplicationConfigProvider = ({
  children,
  config,
}: {
  children: React.ReactNode
  config: ApplicationConfigContext
}): React.JSX.Element => (
  <ApplicationConfigContext.Provider value={config}>
    {children}
  </ApplicationConfigContext.Provider>
)
